import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rYurtDisiTasinmazlariBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rYurtDisiTasinmazlariBilgi>,
  rYurtDisiTasinmazlariBilgi
>(
  ActionSubTypes.API_YURTDISITASINMAZBILGI,
  DefaultInputDataStateModel<pList, rYurtDisiTasinmazlariBilgi>()
);
